// Sources: https://www.youtube.com/watch?v=XeiOnkEI7XI&list=WL&index=4&t=36s
import React, { Component } from "react";
import axios from "axios";
import "./UploadProfileImage.css";

class uploadProfileImage extends Component {
  state = {
    selectedFile: null,
  };

  fileSelectedHandler = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  };

  // TODO Change the post url to the address of the actual deployment
  fileUploadHandler = () => {
    const fd = new FormData();
    fd.append("image_file", this.state.selectedFile, this.state.selectedFile.name);
    axios.post("http://localhost:3000/api/upload", fd).then((res) => {
      console.log(res);
    });
  };

  render() {
    return (
      <div className="upload-profile-image">
        <input type="file" onChange={this.fileSelectedHandler}></input>
        <button onClick={this.fileUploadHandler}>Upload</button>
      </div>
    );
  }
}

export default uploadProfileImage;
